"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
window.addEventListener('DOMContentLoaded', function (event) {
  var navLocationsBtns = document.querySelector('.doctors-locations__nav-btns');
  var cardLocationItem = document.querySelector('.locations-time-card');
  if (navLocationsBtns != null && cardLocationItem) {
    var cardTrack = document.querySelector('.doctors-locations__track');
    var nextButton = document.querySelector('.doctors-locations__button--bottom');
    var prevButton = document.querySelector('.doctors-locations__button--top');
    var allCards = document.querySelectorAll('.locations-time-card').length;
    var cardHeight = cardLocationItem.offsetHeight;
    var cardsHidden = allCards - 4;
    var cardCounter = 0;
    var counter = 0;
    prevButton.style.display = "none";
    if (allCards <= 4) {
      navLocationsBtns.classList.add('hide');
    }
    nextButton.addEventListener('click', function (e) {
      prevButton.style.display = "block";
      counter = counter - cardHeight;
      cardTrack.style.transform = "translateY(" + counter + "px)";
      cardCounter++;
      if (cardCounter == cardsHidden) {
        nextButton.style.display = "none";
      }
    });
    prevButton.addEventListener('click', function (e) {
      nextButton.style.display = "block";
      counter = counter + cardHeight;
      cardTrack.style.transform = "translateY(" + counter + "px)";
      cardCounter--;
      if (cardCounter == 0) {
        prevButton.style.display = "none";
      }
    });

    //Distance calculator for locations based on browser geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showDocLocPosition);
    }
    function showDocLocPosition(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      if (lat && lng) {
        setDriveDistances(lat, lng);
        updateOrderByDistance();
      }
    }
    function updateOrderByDistance() {
      var container = document.getElementById("DocLoc");
      var frag = document.createDocumentFragment();
      var list = document.querySelector(".doctors-locations__track");
      var hospitals = document.querySelectorAll(".locations-time-card");
      var sortedList = _toConsumableArray(hospitals).sort(function (a, b) {
        var d1 = a.querySelector(".distanceFromVisitor");
        var v1 = d1.getAttribute("distance");
        var d2 = b.querySelector(".distanceFromVisitor");
        var v2 = d2.getAttribute("distance");
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      });
      var _iterator = _createForOfIteratorHelper(sortedList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          frag.appendChild(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      list.appendChild(frag);
    }
    function setDriveDistances(lat, lng) {
      document.querySelectorAll(".distanceFromVisitor").forEach(function (d) {
        var uLat = d.getAttribute("lat");
        var uLng = d.getAttribute("lng");
        var fallBackOveride = 9999;
        //Fallbacks for blank geo location values from blank location item for department
        if (uLat == "") {
          uLat = fallBackOveride;
        }
        if (uLng == "") {
          uLng = fallBackOveride;
        }
        if (uLat && uLng) {
          var distance = get2LatLongDistance(uLat, uLng, lat, lng);
          if (uLng != fallBackOveride | uLat != fallBackOveride) {
            d.innerHTML = Math.ceil(distance) + " miles";
          }
          d.setAttribute('distance', distance);
        }
      });
    }
    function get2LatLongDistance(lat1, lon1, lat2, lon2) {
      if (lat1 == lat2 && lon1 == lon2) {
        return 0;
      } else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        return dist;
      }
    }
  }
});